<div *ngIf="user"
    class="agpr-container"
    [agprLoading]="ghostingInClassic"
    [agprGlobalLoading]="true"
>
    <div class = "agpr-center">
        <div class="agpr-userProfile-header">
            <h2
                class="agpr-userProfile-header-name"
            >
                {{user.firstName}} {{user.lastName}}
            </h2>
            <div class="agpr-userProfile-header-id-container">
                <div class="agpr-userProfile-header-id-label">{{ 'UMT.header.userNumber' | localize }}</div>
                <div
                    class="agpr-userProfile-header-id"
                    [ngClass]="{'agpr-userProfile-header-id-neptuneOnly': user?.neptuneOnly}"
                >
                    <span [agprTooltip]="user?.neptuneOnly ? 'UMT.header.neptuneOnly.tooltip' : null">{{user.id}}</span>
                    <a
                        class="agpr-userProfile-header-id-pendoLink"
                        [href]="`https://app.pendo.io/s/5707616250822656/visitor/${user.id}`"
                        target="_blank"
                        [agprTooltip]="'UMT.header.pendoLink.tooltip'"
                        [tooltipAllowsHtml]="true"
                        tooltipPosition="top"
                        tooltipStyleClass="agpr-tooltip-alwaysBeAbove"
                    >
                        <span class="fa-duotone fa-regular fa-magnifying-glass-chart"></span>
                    </a>
                </div>
            </div>
        </div>
        <agpr-scroll-panel>
            <agpr-user-profile
                #userProfile
                [user]="user"
                (ghostIntoAccount)="ghostIn($event)"
            >
            </agpr-user-profile>
        </agpr-scroll-panel>

        <div class="agpr-footer">
            <agpr-action-bar>
                <ng-template #right>
                    <ng-container
                        *ngTemplateOutlet="userProfile.actionButton"
                    ></ng-container>
                    <agpr-button
                        *ngIf="hasGhostInAccess"
                        label="UMT.profile.ghostIn"
                        [disabled]="!primaryAccount || !user.isActive || isReadOnly || isAlreadyGhostedIn || (user?.id === userState?.user?.id)"
                        [style]="buttonTypes.primaryB"
                        (click)="ghostIn()"
                    ></agpr-button>
                    <agpr-button
                        label="save"
                        [disabled]="!user.isActive || isReadOnly || !user.isFormValid()"
                        (click)="accountManagementService.saveUserChanges(user)"
                        [style]="buttonTypes.primary"
                    ></agpr-button>

                    <!-- We must use a hidden form for the classic ghost in -->
                    <form #classicForm ngNoForm [action]="classicGhostInRoute" method="POST" id="hideClassicForm">
                        <input type="number" [value]="user?.id" name="userId"/>
                        <input type="number" [value]="primaryAccount?.id" name="accountId"/>
                    </form>
                </ng-template>
            </agpr-action-bar>
        </div>
    </div>
    <aside class="agpr-sidebar">
        <agpr-right-sidebar
            #rightSidebar
            [agprLoading]="loading"
            [(selectedTabIndex)]="selectedTabIndex"
            (selectedTabIndexChange)="tabChange($event)"
        >
            <agpr-tab
                icon=" fa-list"
                tooltip="UMT.RHP.changelog"
                [id]="'UMT.RHP.changelogTab'"
            >
            </agpr-tab>
            <agpr-tab
                icon=" fa-clock-rotate-left"
                tooltip="UMT.RHP.activityLog"
            >
                <agpr-activity-log [userId]="user.id" />
            </agpr-tab>
        </agpr-right-sidebar>
    </aside>
</div>
